var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_c('el-button',{on:{"click":_vm.refreshDbapi}},[_vm._v("刷新dbapi缓存")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }